import { render } from "./ProvisionPhoneNumber.vue?vue&type=template&id=36e52470"
import script from "./ProvisionPhoneNumber.vue?vue&type=script&lang=js"
export * from "./ProvisionPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__